export default __webpack_public_path__ + "static/media/feature-box-collection-bursars-office-550x310.ba27654e.jpg";